import React from "react";

export default () => {
  return (
    <svg
      width="7px"
      height="12px"
      viewBox="0 0 7 12"
      version="1.1"
      style={{ padding: "0 10px" }}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        id="Wireframe-v4-Layout-v2"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="PWA-Desktop-Page1---Location-Classification---Class-1"
          transform="translate(-765.000000, -218.000000)"
          fill="#000000"
          fillRule="nonzero"
          stroke="#000000"
        >
          <g id="Group-5" transform="translate(248.000000, 201.000000)">
            <g id="Group-14" transform="translate(0.500000, 0.000000)">
              <path
                d="M517.589875,27.9226864 C517.642609,27.9762024 517.714485,28.0062804 517.789875,28.0066851 C517.865266,28.0074516 517.937535,27.9769824 517.989875,27.9226864 L522.705475,23.2066864 C522.758991,23.1539524 522.789459,23.0816864 522.789459,23.0066864 C522.789459,22.9316864 522.75899,22.8594164 522.705475,22.8066864 L517.989875,18.0894864 C517.937141,18.0336274 517.864485,18.0012054 517.787925,18 C517.710972,17.9988615 517.637145,18.0285494 517.582845,18.0828464 C517.528548,18.1371434 517.498861,18.2109664 517.5,18.2875364 C517.501205,18.3644894 517.533627,18.4371464 517.589877,18.4894864 L522.105477,23.0066864 L517.589877,27.5226864 C517.536361,27.5754204 517.506674,27.6476864 517.506674,27.7226864 C517.506674,27.7976864 517.536362,27.8695664 517.589877,27.9226864 L517.589875,27.9226864 Z"
                id="Path"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};
